import { jsx, Fragment } from "react/jsx-runtime";
import { MarkdownRenderer } from "../../Media/MarkdownRenderer/index.js";
import { Link } from "../../Navigation/Link/index.js";
const buildLinkOverride = (color) => {
  const LinkOverride = ({ children, ...props }) => {
    return /* @__PURE__ */ jsx(Link, { ...props, color, children });
  };
  return LinkOverride;
};
function TextOverride({ children }) {
  return /* @__PURE__ */ jsx(Fragment, { children });
}
function AnnouncementBannerMarkdown({
  color,
  text,
  linksAsText = false,
  uniqueId
}) {
  const overrides = {
    a: linksAsText ? TextOverride : buildLinkOverride(color)
  };
  return /* @__PURE__ */ jsx(
    MarkdownRenderer,
    {
      linkColor: color,
      markdown: text,
      overrides,
      "data-testid": uniqueId
    }
  );
}
export {
  AnnouncementBannerMarkdown
};
